import { useState, useEffect } from "react";
import ReactDOM from "react-dom";
//Pay attention when using this component
//this is used as a wrapper and has it's own state so any component used this should always return this
//and not cases of returns (such as return null)
const CreateReactPortal = (component, domNode, disablePortal) => {
  const [domReady, setDomReady] = useState(false);

  useEffect(() => setDomReady(true), []);

  //if there isn't any component return null
  if (!component) {
    return null;
  }
  //if there isn't any domNode to add the portal or disablePortal property is true return just the component
  if (disablePortal || !domNode) {
    return component;
  }

  return domReady && ReactDOM.createPortal(component, domNode);
};

export default CreateReactPortal;
